import Footer from '@/components/Footer';
import Header from '@/components/Header';
import LessonCourseBanner from '@/ui/components/LessonCourseBanner';

type Props = {
  topArea?: React.ReactNode;
  children?: React.ReactNode;
  isLessonCourseBanner?: boolean;
};

const Component: React.FC<Props> = ({
  topArea,
  children,
  isLessonCourseBanner = false,
}) => {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <div className="flex-1 overflow-x-hidden">
        <div className="mx-auto max-w-[640px] px-2">
          <div className="py-3 md:py-8">
            {topArea}
            <div className="flex w-full flex-col gap-y-6">{children}</div>
          </div>
        </div>
      </div>
      <Footer />
      {isLessonCourseBanner && <LessonCourseBanner />}
    </div>
  );
};

export default Component;
